import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInboxLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16.382 4C17.0854 4 17.7327 4.36904 18.0929 4.96426L18.1708 5.10557L21.6833 12.1305C21.8569 12.4777 21.9611 12.8545 21.991 13.24L22 13.4721V19C22 20.0544 21.1841 20.9182 20.1493 20.9945L20 21H4C2.94564 21 2.08183 20.1841 2.00549 19.1493L2 19V13.4721C2 13.084 2.07531 12.7004 2.22094 12.3422L2.31672 12.1305L5.82918 5.10557C6.14376 4.4764 6.76336 4.06242 7.4568 4.00649L7.61803 4H16.382ZM8 14H4V19H20V14H16V14.5C16 15.3284 15.3284 16 14.5 16H9.5C8.67157 16 8 15.3284 8 14.5V14ZM16.382 6H7.61803L4.61803 12H8.5C9.2797 12 9.92045 12.5949 9.99313 13.3555L10 13.5V14H14V13.5C14 12.7203 14.5949 12.0796 15.3555 12.0069L15.5 12H19.382L16.382 6Z" })
});
export default SvgInboxLine;
